import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobPageDto } from "@/api/dtos";
import type { BackgroundJobPage, BackgroundJobStatus, BackgroundJobTrigger } from "./_models/BackgroundJob";
import { toBackgroundJobFromBackgroundJobDto } from "./_transformers/toBackgroundJobFromBackgroundJobDto";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

export interface GetBackgroundJobPageArgs {
  kind?: string;
  statuses?: BackgroundJobStatus[];
  trigger?: BackgroundJobTrigger;
  offset: number;
  limit: number;
}

const toParams = (args: GetBackgroundJobPageArgs): Record<string, string> => {
  const params: Record<string, string> = { offset: String(args.offset), limit: String(args.limit) };
  if (args.kind) params.kind = args.kind;
  if (args.statuses && args.statuses.length > 0) params.status = args.statuses.join(",");
  if (args.trigger) params.trigger = args.trigger;
  return params;
};

/** A page of background jobs (GET /background-jobs), newest first, with the filter's total. */
export const getBackgroundJobPageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBackgroundJobPage: builder.query<BackgroundJobPage, GetBackgroundJobPageArgs>({
      queryFn: async (args) => {
        try {
          const params = toParams(args);
          const res = await axios.get<BackgroundJobPageDto>(
            `${backendBase()}/background-jobs`,
            { params, headers: { Accept: "application/json" } },
          );
          const backgroundJobs = res.data.backgroundJobs.map((x) => toBackgroundJobFromBackgroundJobDto(x));
          return { data: { backgroundJobs, total: res.data.total } };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      providesTags: [{ type: BackgroundJobTags.BackgroundJob, id: "LIST" }],
    }),
  }),
});

export const getBackgroundJobPage = getBackgroundJobPageApi.endpoints.getBackgroundJobPage;
